import { IRecentActivityItem, RecentActivityType } from 'core/types/recent-activity.interface';

export function isAcceptedReferralActivity(item: IRecentActivityItem): boolean {
  return item.activity_type === RecentActivityType.REFERRAL_SENT && item.metadata['accepted'] === true;
}
